import type { OnboardingOnboardingAnswers } from '@customerio/hydra-ui-api';
import { isEmptyString } from '@/utils/string';

export type OnboardingAnsweredInput = {
  answers: OnboardingOnboardingAnswers | undefined;
  /** With AI on the wizard asks four questions; without it get-started asks only the platform one. */
  isAiEnabled: boolean;
};

const hasListenTargets = (answers: OnboardingOnboardingAnswers | undefined): boolean =>
  (answers?.listen_targets?.length ?? 0) > 0;

/**
 * Whether the user finished the question set they were given. Routing treats
 * an answered user as done with `/onboarding`, so this must not read true
 * mid-conversation: the wizard records `listen_targets` at its third question
 * of four, and counting that alone strands a user who leaves before the last
 * one with no route back into the chat.
 */
export function hasAnsweredOnboarding({ answers, isAiEnabled }: OnboardingAnsweredInput): boolean {
  if (!isAiEnabled) {
    return hasListenTargets(answers);
  }
  return (
    !isEmptyString(answers?.goal) &&
    answers?.starting_point != null &&
    hasListenTargets(answers) &&
    answers.is_implementer != null
  );
}
